import zhtLocale from 'element-ui/lib/locale/lang/zh-TW';

const cnt = {
    message: {
        topnav: {
            welcome: "歡迎您",
            customer_service: "客戶服務",
            seachplaceholder: "檢索文章/用戶...",
            notice: "消息",
            userindex: "我的主页",
            myindex: "我的博客",
            mygroup: "我的群吧",
            myfavorite: "我的收藏",
            mycomment: "我收到的評論",
            myqqh: "我的悄悄話",
            myfuns: "我的粉絲",
            likeme: "我收到的讚",
            profile: "我的賬號",
            wxcprofile: "賬號管理",
            logout: "退出登錄",
            login: "登錄/註冊",
            admin: "運營管理",
            editbtn: "發博文",
            group_editbtn: "發帖",
            mygroupblog: "我加入的群博",
            editbtn_dropdown_0: "發文致",
        },
        blog: {
            index_menu_blog: "博客",
            menu_follow: "關注",
            menu_recommend: "精選",
            menu_hot: "熱榜",
            index_title_hot: "熱門博主",
            bloggerlist_refresh: "換一批",
            blogger_follow: "關注",
            blogger_remove_follow: "取消關注",
            blogger_followed: "已關注",
            notice_menu_all: "全部消息",
            notice_menu_comment: "我收到的評論",
            notice_menu_qqh: "我的悄悄話",
            notice_menu_funs: "我的粉絲",
            notice_menu_likeme: "我收到的讚",
            index_hot_categorymenu: "其它分類",
            btn_regist_now: "立即激活博客",
            blog_regist_prefix: "請點擊下面按鈕激活您的博客。我們會自動為您生成一個博客名:",
            blog_regist_suffix: "如果您對這個名字不滿意,可以點擊“我的賬號”，然後再點擊“博客設置”，進行修改。",
        },
        group: {
            index_menu_group: "群吧",
            index_discover: "最新群吧",
            index_title_hot: "熱門群吧",
            index_article_hot: "推广置顶",
            index_hot_categorymenu: "其它分类",
            index_new_btn: "+ 新建群吧",
            my_group_add: "我加入的群吧",
            my_group_create: "我創建的群吧",
            group_add: "加入",
            group_remove_add: "退出",
            group_added: "已加入",
            group_is_private:"非公開群吧",
            group_is_open:"公開群吧",
            group_member_unit:"個群員",
            group_status_title:"您的動態",
            group_todaynew_label:"今日新帖",
            group_lastmonth_label:"上月發帖",
            group_promo_label:"首頁推廣帖",
            member_list_label0:"待審核",
            member_list_label1:"群員",
            discuss: "討論",
            rule:"群規",
            summary:"群吧簡介",
            info:"群吧介绍",
            tag_new_btn: "添加話題",
            group_add_member: "邀請",
            group_search_pleacholder: "搜索",
            group_add_pleacholder: "按筆名搜索",
            group_create_here: "您創建的群吧會在這",
            group_added_here: "您加入的群吧會在這",
            group_status_explain:"您的動態是-您創建和加入的所有群吧的，最近帖子更新动态",
            group_hot_article_explain:"公开/非公开群吧的首页推广贴，除了该群吧首页也会出现在此列表"
        },
        groupindex: {
            header_member: "成员：",
            left_title2: "群组成员",
            left_btn_add: "输入名字查找想邀请的群员",
            group_blog_add_member: "邀请成员",
            group_blog_remove_member: "移除成员",
            group_blog_remove_member_alert: "确定移除该成员吗？",
            group_blog_add_pleacholder: "按笔名或邮箱",
            group_search_btn: "查詢",
            group_search_opt0: "按作者",
            group_search_opt1: "按標題",
            group_search_opt2: "顯示回復"
        },
        userindex: {
            bubble_iknow: "知道了",
            name_noregist: "未開通博客",
            discrib_noregist: "此用戶尚未開通博客...",
            header_funs: "粉絲：",
            header_readcount: "博客訪問：",
            menu_title: "博文目錄",
            menu_btn_manage: "博文管理",
            article_tab0: "最新博文",
            article_tab1: "最熱博文",
            article_tab2: "新評博文",
            myarticle_tab0: "博客文章",
            myarticle_tab1: "群组帖子",
            myarticle_tab2: "评论",
            left_title2: "群博群員",
            left_btn_add: "添加作者",
            group_blog_add_member: "添加作者",
            group_blog_remove_member: "移除作者",
            group_blog_remove_member_alert: "確定移除作者嗎？",
            group_blog_add_pleacholder: "按筆名或電郵",
        },
        article: {
            author: "作者",
            read_count: "閱讀",
            edit: "編輯",
            comment_delet: "刪除",
            comment_cancel: "取消",
            comment_del_confirm: "確定刪除這條評論嗎？",
            reply_del_confirm: "確定刪除這條回覆嗎？",
            black_list: "加入黑名單",
            comment_placeholder: "寫下您的評論...",
            reply: "回覆",
            reply_count: "條回覆",
            comment_button: "發表評論",
            comment_text: "評論",
            hide_text: "隐",
            group_hide_text:"非公開",
            like_text: "喜歡",
            bookmark_text: "收藏",
            share_text: "分享",
            share_wechat_text: "打開微信掃一掃[Scan QR Code]，打開網頁後點擊屏幕右上角分享按鈕",
            share_wechat_close: "關閉",
            delete_confirm: "確定刪除這篇文章嗎？",
            comment_more: "加載更多評論",
            recomment_text: "相關推薦",
            post: "發表於"
        },
        setting: {
            menu_bolg: "博客設置",
            menu_accout: "賬號設置",
            menu_blacklist: "黑名單",
            blog_title: "博客設置",
            blog_bgimg_btn: "修改博客背景",
            blog_name: "博客名",
            blog_name_ph: "博客名",
            blog_descript: "博客簡介",
            blog_descript_ph: "博客簡介",
            blog_save_btn: "保存",
            blog_saved: "已保存",
            accout_title: "賬號設置",
            accout_avatar_btn: "修改我的頭像",
            accout_avatar_save_btn: "修改",
            accout_cancel_btn: "取消",
            accout_name: "筆名",
            accout_name_err: "筆名不能為空",
            accout_name_ph: "筆名",
            accout_descript: "個人簡介",
            accout_descript_ph: "寫點什麼介紹你自己吧",
            accout_country: "所在國家/地區",
            accout_accout: "登錄賬號",
            accout_pass: "修改密碼",
            accout_pass_ph: "密碼",
            accout_comfirm_ph: "確認密碼",
            accout_pass_btn: "修改密碼",
            black_title: "黑名單",
            black_remove: "從黑名單中移除",
            blogregist_btn: "開通博客"
        },
        editor: {
            page_title: "發博文",
            wenji_lable: "文章所屬目錄：",
            wenji_new_btn: "+ 新建目錄",
            wenji_new_title: "新建博文目錄",
            wenji_setting_title: "目錄設置",
            wenji_new_placeholder: "請輸入目錄名稱",
            wenji_new_radio1: "公開目錄",
            wenji_new_radio2: "隱藏目錄",
            wenji_new_error: "與現有目錄名重複",
            wenji_new_cancel: "取 消",
            wenji_new_ok: "確 定",
            wenji_update_btn: "修改",
            wenji_update_menu: "修改目錄名稱",
            wenji_delet_menu: "刪除目錄",
            wenji_comfirm_title: "確定删除博文目錄 ",
            wenji_comfirm_title1: " 嗎？",
            wenji_comfirm_btn: "删除",
            wenji_cancel_btn: "取消",
            wenji_title_suffix: " (隱)",
            group_new_title: "新建群吧",
            group_comfirm_title: "確定刪除群吧",
            group_delet_menu: "刪除群吧",
            group_new_placeholder: "请输入群组名称",
            group_new_error: "與現有群组名重複",
            group_setting_title: "群组設置",
            article_new_btn: "新建文章",
            autosaving: "自動保存中...",
            autosaved: "已自動保存",
            title_ph: "请输入博文標題",
            btn_publish: "發表博文",
            btn_update: "發表更新",
            btn_canceledit: "放棄編輯",
            canceledit_comfirm_title: "放棄編輯，將退回到您上次发布此文章的版本！是否放棄？",
            canceledit_comfirm_btn: "放 棄",
            draft_btn_save: "保存草稿",
            draft_btn_refresh: "清空草稿內容",
            draft_comfirm_text: "您要清空草稿的標題和內容嗎？",
            notice: "注：发表博客文章時請不要提供廣告信息或不友好信息，本站保留拒絕的權利。",
            recommend_lable: "當前博文可否評論：",
            tag_btn_add: "+ 添加內容相關關鍵詞",
            tag_placeholder: "請輸入標籤",
            tag_lable: "博文標籤：",
        },
        qqh: {
            modal_title_prefix: "向",
            modal_title: "發送悄悄話",
            modal_placeholder: "請輸入內容",
            modal_succese: "發送成功",
            modal_btn_send: "發 送",
            modal_btn_cancel: "取 消",
            btn_send: "發悄悄話"
        }
    },
    ...zhtLocale
}
export default cnt